import { buildListFilterUrl } from '@/helpers/filters/buildListFilterUrl.js';

export const buildDateRangeFilterUrl = (resource, filterValues, sort) => {
    const filterObject = {};

    if (filterValues.period) {
        if (filterValues.period === 'custom') {
            filterObject.period = 'custom';
            if (filterValues.periodStart_gte) {
                filterObject.periodStart_gte = filterValues.periodStart_gte;
            }
            if (filterValues.periodEnd_lte) {
                filterObject.periodEnd_lte = filterValues.periodEnd_lte;
            }
        } else {
            filterObject.period = filterValues.period;
        }
    }

    if (filterValues.tagId) {
        filterObject['tags->id_in'] = [filterValues.tagId];
    }

    const displayedSources = Object.keys(filterObject);
    const baseUrl = buildListFilterUrl(`/${resource}`, filterObject, displayedSources);
    const joiner = baseUrl.includes('?') ? '&' : '?';

    return `${baseUrl}${joiner}order=DESC&sort=${sort}`;
};
